<div class="word-guess-keyboard">
  <div class="word-guess-keyboard-row" *ngFor="let row of rows; let rowIndex = index">
    <ion-button
      class="word-guess-keyboard-key word-guess-keyboard-action"
      *ngIf="rowIndex === rows.length - 1"
      [disabled]="disabled || !canDelete"
      [attr.aria-label]="'WORD_GUESS.keyboard.delete' | translate"
      (click)="onDelete()"
    >
      <ion-icon name="backspace-sharp" slot="icon-only" />
    </ion-button>

    <ion-button
      class="word-guess-keyboard-key"
      *ngFor="let letter of row"
      [ngClass]="'is-' + letterState(letter)"
      [disabled]="disabled"
      (click)="onLetter(letter)"
    >
      <span class="word-guess-keyboard-key-label">{{ letter }}</span>
    </ion-button>

    <ion-button
      class="word-guess-keyboard-key word-guess-keyboard-action"
      *ngIf="rowIndex === rows.length - 1"
      [disabled]="disabled || !canSubmit"
      (click)="onEnter()"
    >
      <span class="word-guess-keyboard-key-label">
        {{ 'WORD_GUESS.keyboard.enter' | translate }}
      </span>
    </ion-button>
  </div>
</div>
